export default {"src":"/_next/static/media/airbnb.dd61d781.svg","height":30,"width":92};